import React from "react";

const DeleteIcon = ({ width, height, color, onClick,style }) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox='0 0 19 18'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      onClick={onClick}
      style={style}
    >
      <g clipPath='url(#clip0_1757_8478)'>
        <path d='M1.92139 3H17.9214' stroke={color} strokeLinecap='round' />
        <path d='M6.92139 1H11.9214' stroke={color} strokeLinecap='round' />
        <path d='M8.10889 8L8.10889 13' stroke={color} strokeLinecap='round' />
        <path d='M12.1089 8L12.1089 13' stroke={color} strokeLinecap='round' />
        <path d='M12.1089 8L12.1089 13' stroke={color} strokeLinecap='round' />
        <mask id='path-6-inside-1_1757_8478' fill='white'>
          <path d='M3.92139 3H15.9214V17C15.9214 17.5523 15.4737 18 14.9214 18H4.92139C4.3691 18 3.92139 17.5523 3.92139 17V3Z' />
        </mask>
        <path
          d='M3.92139 3H15.9214H3.92139ZM16.9214 17C16.9214 18.1046 16.026 19 14.9214 19H4.92139C3.81682 19 2.92139 18.1046 2.92139 17H4.92139H14.9214H16.9214ZM4.92139 19C3.81682 19 2.92139 18.1046 2.92139 17V3H4.92139V17V19ZM16.9214 3V17C16.9214 18.1046 16.026 19 14.9214 19V17V3H16.9214Z'
          fill={color}
          mask='url(#path-6-inside-1_1757_8478)'
        />
      </g>
      <defs>
        <clipPath id='clip0_1757_8478'>
          <rect
            width='18'
            height='18'
            fill='white'
            transform='translate(0.921387)'
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export default DeleteIcon;
